// Временная замена Timepad на всех непрошедших собственных мероприятиях.
export const MANUAL_REGISTRATION_ENABLED = false;

// Временно для проверки формы: показывать успех без обращения к серверу.
export const MANUAL_REGISTRATION_MOCK_ENABLED = false;

// Общий customFetch добавляет префикс /api/v1.
export const MANUAL_REGISTRATION_API_URL = '/main/event_registrations/';

export const REGISTRATION_FIELDS = [
  {
    name: 'last_name',
    label: 'Фамилия',
    type: 'text',
    autocomplete: 'family-name',
  },
  {
    name: 'first_name',
    label: 'Имя',
    type: 'text',
    autocomplete: 'given-name',
  },
  {
    name: 'company',
    label: 'Компания',
    type: 'text',
    autocomplete: 'organization',
  },
  {
    name: 'position',
    label: 'Должность',
    type: 'text',
    autocomplete: 'organization-title',
  },
  {
    name: 'business_field',
    label: 'Сфера деятельности компании',
    type: 'text',
    autocomplete: 'off',
  },
  { name: 'phone', label: 'Телефон', type: 'tel', autocomplete: 'tel' },
  { name: 'email', label: 'Эл. почта', type: 'email', autocomplete: 'email' },
  {
    name: 'telegram_nick',
    label: 'Ник в Телеграм',
    type: 'text',
    autocomplete: 'off',
  },
] as const;

export type RegistrationFieldName =
  (typeof REGISTRATION_FIELDS)[number]['name'];

export interface ManualRegistration
  extends Record<RegistrationFieldName, string> {
  event: number;
  promo_code: string;
  captcha_token: string;
}

export interface ManualRegistrationResponse {
  id: number;
  message: string;
}
